import React, { useEffect } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';

import { Link } from 'react-router-dom';

import {
  useQuery,
  useHttpStatus,
} from '~/commons/hooks';

import AnimPending from '~/commons/components/AnimPending.jsx';

import { env, meta } from '~/commons/config';

const PageVerifyUser = () => {
  const [res, req] = useHttpStatus();
  const { key } = useQuery();

  meta.set({ title: '驗證電郵地址' });

  useEffect(() => {
    if (key) {
      req({
        method: 'post',
        url: 'api/core/registrants/verify',
        data: { key },
      });
    }
  }, [key]);

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-4">
          {res.status === 'pending' && (
            <AnimPending />
          )}
          {(!key || res.status === 'error') && (
            <div>
              <h1 className="text-danger">
                <FA icon={faExclamationCircle} />
              </h1>
              <h3>{res.payload}</h3>
              <p>
                <Link to='/auth'>
                  登入
                </Link>
                &nbsp;/&nbsp;
                <Link to='/auth/register'>
                  重新註冊
                </Link>
                .
              </p>
            </div>
          )}
          {res.status === 'success' && (
            <div className="text-center">
              <h1 className="text-success display-2">
                <FA icon={faCheckCircle} />
              </h1>
              <h3>確認成功!</h3>
              <p className="pt-3">
                <Link
                  className="btn btn-block btn-primary"
                  to='/auth'
                >
                  登入帳號
                </Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageVerifyUser;
